import moment from "moment";
import * as app_consts from "../../../../../constants/react_app_consts";
import {
    formatWeighbridgeWeightMt,
    resolveGrnNetWeight,
    resolveWeighbridgeNetWeight,
} from "../../../../../utils/weighbridgeUtils";

const extractProductNames = (value, names = []) => {
    if (!value) return names;

    if (Array.isArray(value))
    {
        value.forEach((item) => extractProductNames(item, names));
        return names;
    }

    if (typeof value === "string")
    {
        const normalizedValue = value.trim();
        if (normalizedValue)
        {
            names.push(normalizedValue);
        }
        return names;
    }

    if (typeof value === "object")
    {
        const productName =
            value?.product_name ||
            value?.product_label ||
            value?.product?.product_name ||
            value?.product?.product_label ||
            value?.product ||
            value?.name ||
            "";
        if (productName)
        {
            names.push(productName);
        }
    }

    return names;
};

const joinUniqueProductNames = (...sources) =>
    [...new Set(sources.flatMap((source) => extractProductNames(source, [])))]
        .filter(Boolean)
        .join(", ") || "--";

const resolveTruckRegistration = (item = {}) =>
    item?.weigh_bridge_ticket?.truck_licence_plate ||
    item?.weigh_bridge_ticket?.truck_license_plate ||
    item?.truck_licence_plate ||
    item?.truck_license_plate ||
    item?.loading_order?.truck_license_plate ||
    item?.loading_order?.truck_licence_plate ||
    "--";


export const export_to_csv_fun = async (data, type) => {
    let csv_data = [];
    let title;
    let filename;
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    switch (type)
    {
        case app_consts.USER_LIST_TYPE:
            title = "United African Grain Users List";
            filename = `United African Grain Users List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.WAREHOUSE_INVENTORY_LIST:
            title = "United African Grain Warehouse Inventory List";
            filename = `United African Grain Warehouse Inventory List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.GOODS_RECEIVED_WEIGH_BRIDGE_TICKET_LIST:
            title = "United African Grain Goods Received List";
            filename = `United African Grain Goods Received List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.CLIENT_GOODS_RECEIVED_LIST:
            title = "United African Grain Goods Received List";
            filename = `United African Grain Goods Received List (as of ${cur_dt})`;

            // Restructure Export Data
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.DELIVERY_NOTES_WEIGH_BRIDGE_TICKET_LIST:
            title = "United African Grain Delivery Notes List";
            filename = `United African Grain Delivery Notes List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.CLIENT_DELIVERY_NOTES_LIST:
            title = "United African Grain Delivery Notes List";
            filename = `United African Grain Delivery Notes List (as of ${cur_dt})`;

            // Restructure Export Data
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.CUSTOMER_USER_ACCOUNT_LIST:
            title = "United African Grain Individual Customerss Account List";
            filename = `United African Grain Individual Customers Account List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.COMPANY_USER_ACCOUNT_LIST:
            title = "United African Grain Company Accounts List";
            filename = `United African Grain Company Accounts List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.TRUCK_DRIVER_USER_ACCOUNT_LIST:
            title = "United African Grain Truck Driver Accounts List";
            filename = `United African Grain Truck Driver Accounts List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.EMPLOYEE_LIST_TYPE:
            title = "United African Grain Employee Accounts List";
            filename = `United African Grain Employee Accounts List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
        case app_consts.BRANCH_LOCATION_LIST:
            title = "United African Grain Branch Locations List";
            filename = `United African Grain Branch Locations List (as of ${cur_dt})`;

            // Restructure Export Data 
            csv_data = await restruc_csv_data(data, type);

            break;
    }

    const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        showLabels: true,
        showTitle: true,
        title: title,
        useTextFile: false,
        useBom: true,
        filename: filename,
        useKeysAsHeaders: true,
    };

    return { csv_data, options };
};

// Restructure CVS ata
const restruc_csv_data = async (data, type) => {
    let csv_data;

    switch (type)
    {
        case app_consts.USER_LIST_TYPE:
            // Restructure Export Data 
            csv_data = data?.map((user_data) => ({
                first_name: user_data.first_name,
                middle_name: user_data.middle_name,
                surname: user_data.surname,
                phone_number: user_data.phone_number,
                email_address: user_data.email_address,
                account_status: user_data.account_status,
                registration_date: moment(user_data.registration_date).format("YYYY-MM-DD h:mm:ss a"),
                branch_physical_address: user_data.branch_physical_address,
                branch_area: user_data.branch_area,
                branch_province_name: user_data.branch_province_name,
                branch_country_name: user_data.branch_country_name,
            }));
            break;
        case app_consts.WAREHOUSE_INVENTORY_LIST:
            // Restructure Export Data 
            if (Array.isArray(data))
            {
                csv_data = data?.map((inventory) => ({
                    record_type: "stock_snapshot",
                    product_id: inventory.product_id,
                    product_name: inventory.product_name,
                    product_group: inventory.group_name || inventory.product_group || "",
                    product_type: inventory.product_type,
                    physical_stock_mt: parseFloat(
                        inventory.sum_total_physical_in_mt ??
                        inventory.physical_store_capacity ??
                        0.00
                    ).toFixed(2),
                    virtual_stock_mt: parseFloat(
                        inventory.sum_total_virtual_in_mt ??
                        inventory.virtaul_store_capacity ??
                        inventory.virtual_store_capacity ??
                        0.00
                    ).toFixed(2),
                    total_stock_mt: parseFloat(
                        inventory.total_mt ??
                        inventory.total_warehouse_store ??
                        0.00
                    ).toFixed(2),
                    stock_status: inventory.stock_status || "",
                    movement_date: "",
                    movement_timestamp: "",
                    movement_direction: "",
                    movement_type: "",
                    movement_mt: "",
                    signed_movement_mt: "",
                    inventory_type: "",
                    packet_size: "",
                    unit_measurement: "",
                    reason_message: "",
                }));
            } else
            {
                const stockSnapshots = data?.stockSnapshots || [];
                const productHistory = data?.productHistory || [];
                const stockInMovement = data?.stockInMovement || [];
                const stockOutMovement = data?.stockOutMovement || [];

                csv_data = [
                    ...stockSnapshots.map((inventory) => ({
                        record_type: "stock_snapshot",
                        product_id: inventory.product_id,
                        product_name: inventory.product_name,
                        product_group: inventory.group_name || inventory.product_group || "",
                        product_type: inventory.product_type,
                        physical_stock_mt: parseFloat(
                            inventory.sum_total_physical_in_mt ??
                            inventory.physical_store_capacity ??
                            0.00
                        ).toFixed(2),
                        virtual_stock_mt: parseFloat(
                            inventory.sum_total_virtual_in_mt ??
                            inventory.virtaul_store_capacity ??
                            inventory.virtual_store_capacity ??
                            0.00
                        ).toFixed(2),
                        total_stock_mt: parseFloat(
                            inventory.total_mt ??
                            inventory.total_warehouse_store ??
                            0.00
                        ).toFixed(2),
                        stock_status: inventory.stock_status || "",
                        movement_date: "",
                        movement_timestamp: "",
                        movement_direction: "",
                        movement_type: "",
                        movement_mt: "",
                        signed_movement_mt: "",
                        inventory_type: "",
                        packet_size: "",
                        unit_measurement: "",
                        reason_message: "",
                    })),
                    ...productHistory.map((item) => ({
                        record_type: "product_history",
                        product_id: item.product_id || "",
                        product_name: item.product_name || "",
                        product_group: item.product_group || "",
                        product_type: item.product_type || "",
                        physical_stock_mt: "",
                        virtual_stock_mt: "",
                        total_stock_mt: "",
                        stock_status: "",
                        movement_date: item.movement_date || "",
                        movement_timestamp: item.movement_timestamp || "",
                        movement_direction: item.movement_direction || "",
                        movement_type: item.movement_type || "",
                        movement_mt: item.movement_mt ?? "",
                        signed_movement_mt: item.signed_movement_mt ?? "",
                        inventory_type: item.inventory_type || "",
                        packet_size: item.packet_size || "",
                        unit_measurement: item.unit_measurement || "",
                        reason_message: item.reason_message || "",
                    })),
                    ...stockInMovement.map((item) => ({
                        record_type: "daily_stock_in",
                        product_id: "",
                        product_name: "",
                        product_group: item.product_group || "",
                        product_type: "",
                        physical_stock_mt: "",
                        virtual_stock_mt: "",
                        total_stock_mt: "",
                        stock_status: "",
                        movement_date: item.movement_date || "",
                        movement_timestamp: "",
                        movement_direction: item.movement_direction || "inbound",
                        movement_type: item.movement_type || "daily_stock_in",
                        movement_mt: item.movement_mt ?? "",
                        signed_movement_mt: item.signed_movement_mt ?? "",
                        inventory_type: "",
                        packet_size: "",
                        unit_measurement: "",
                        reason_message: "",
                    })),
                    ...stockOutMovement.map((item) => ({
                        record_type: "daily_stock_out",
                        product_id: "",
                        product_name: "",
                        product_group: item.product_group || "",
                        product_type: "",
                        physical_stock_mt: "",
                        virtual_stock_mt: "",
                        total_stock_mt: "",
                        stock_status: "",
                        movement_date: item.movement_date || "",
                        movement_timestamp: "",
                        movement_direction: item.movement_direction || "outbound",
                        movement_type: item.movement_type || "daily_stock_out",
                        movement_mt: item.movement_mt ?? "",
                        signed_movement_mt: item.signed_movement_mt ?? "",
                        inventory_type: "",
                        packet_size: "",
                        unit_measurement: "",
                        reason_message: "",
                    })),
                ];
            }
            break;
        case app_consts.GOODS_RECEIVED_WEIGH_BRIDGE_TICKET_LIST:
            // Restructure Export Data 
            csv_data = data?.map((goods_received) => ({
                goods_received_ref_number: goods_received?.goods_received?.goods_received_ref_number,
                user_account_no: goods_received?.user_account?.unique_identification_number,
                product_name: joinUniqueProductNames(
                    goods_received?.product?.product_name,
                    goods_received?.product_name,
                    goods_received?.grn_products,
                    goods_received?.goods_received_products,
                    goods_received?.goods_received?.goods_received_products,
                    goods_received?.product_list,
                ),
                truck_licence_plate: resolveTruckRegistration(goods_received),
                tonnage: formatWeighbridgeWeightMt(
                    resolveGrnNetWeight(
                        goods_received?.weigh_bridge_ticket?.net_weight || "",
                        goods_received?.weigh_bridge_ticket?.first_weight || "",
                        goods_received?.weigh_bridge_ticket?.second_weight || "",
                    ),
                    { fallback: "--" }
                ),
                gross_weight: goods_received?.weigh_bridge_ticket?.first_weight ? parseFloat(goods_received?.weigh_bridge_ticket?.first_weight || 0.00).toFixed(2) : "--",
                tare_weight: goods_received?.weigh_bridge_ticket?.second_weight ? parseFloat(goods_received?.weigh_bridge_ticket?.second_weight || 0.00).toFixed(2) : "--",
                net_weight: goods_received?.weigh_bridge_ticket?.first_weight && goods_received?.weigh_bridge_ticket?.second_weight
                    ? resolveGrnNetWeight(
                        goods_received?.weigh_bridge_ticket?.net_weight || "",
                        goods_received?.weigh_bridge_ticket?.first_weight || "",
                        goods_received?.weigh_bridge_ticket?.second_weight || "",
                    )
                    : "--",
                time_in: goods_received?.weigh_bridge_ticket?.time_in ? moment(goods_received?.weigh_bridge_ticket?.time_in).format("YYYY-MM-DD h:mm:ss") : "--",
                time_out: goods_received?.weigh_bridge_ticket?.time_out ? moment(goods_received?.weigh_bridge_ticket?.time_out).format("YYYY-MM-DD h:mm:ss") : "--",
                weigh_bridge_ticket_reference_no: goods_received?.weigh_bridge_ticket?.weigh_bridge_ticket_reference_no,
                weigh_bridge_ticket_status: goods_received?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status,
                weigh_bridge_ticket_type: goods_received?.weigh_bridge_ticket_type?.weigh_bridge_ticket_type,
                branch_area: goods_received?.branch_location?.branch_area,
                branch_physical_address: goods_received?.branch_location?.branch_physical_address,
                consigner_type: goods_received?.consigner_type?.consigner_type,
            }));
            break;
        case app_consts.CLIENT_GOODS_RECEIVED_LIST:
            // Restructure Export Data
            csv_data = data?.map((goods_received) => ({
                goods_received_ref_number: goods_received?.goods_received?.goods_received_ref_number || "--",
                consigner_name: goods_received?.consigner?.name || "--",
                consigner_account_no: goods_received?.consigner?.unique_identification_number || "--",
                product_name: joinUniqueProductNames(
                    goods_received?.product?.product_name,
                    goods_received?.product_name,
                    goods_received?.grn_products,
                    goods_received?.goods_received_products,
                    goods_received?.goods_received?.goods_received_products,
                    goods_received?.product_list,
                ),
                weigh_bridge_ticket_reference_no: goods_received?.weigh_bridge_ticket?.weigh_bridge_ticket_reference_no || "--",
                truck_licence_plate: resolveTruckRegistration(goods_received),
                tonnage: formatWeighbridgeWeightMt(
                    resolveGrnNetWeight(
                        goods_received?.weigh_bridge_ticket?.net_weight || "",
                        goods_received?.weigh_bridge_ticket?.first_weight || "",
                        goods_received?.weigh_bridge_ticket?.second_weight || "",
                    ),
                    { fallback: "--" }
                ),
                gross_weight: goods_received?.weigh_bridge_ticket?.first_weight ? parseFloat(goods_received?.weigh_bridge_ticket?.first_weight || 0.00).toFixed(2) : "--",
                tare_weight: goods_received?.weigh_bridge_ticket?.second_weight ? parseFloat(goods_received?.weigh_bridge_ticket?.second_weight || 0.00).toFixed(2) : "--",
                net_weight: goods_received?.weigh_bridge_ticket?.first_weight && goods_received?.weigh_bridge_ticket?.second_weight
                    ? resolveGrnNetWeight(
                        goods_received?.weigh_bridge_ticket?.net_weight || "",
                        goods_received?.weigh_bridge_ticket?.first_weight || "",
                        goods_received?.weigh_bridge_ticket?.second_weight || "",
                    )
                    : "--",
                time_in: goods_received?.weigh_bridge_ticket?.time_in ? moment(goods_received?.weigh_bridge_ticket?.time_in).format("YYYY-MM-DD h:mm:ss") : "--",
                time_out: goods_received?.weigh_bridge_ticket?.time_out ? moment(goods_received?.weigh_bridge_ticket?.time_out).format("YYYY-MM-DD h:mm:ss") : "--",
                weigh_bridge_ticket_status: goods_received?.weigh_bridge_ticket?.weigh_bridge_ticket_status || "--",
                weigh_bridge_ticket_type: goods_received?.weigh_bridge_ticket?.weigh_bridge_ticket_type || goods_received?.weigh_bridge_ticket_type?.weigh_bridge_ticket_type || "--",
                created_date: goods_received?.goods_received?.inserted_at ? moment(goods_received?.goods_received?.inserted_at).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.DELIVERY_NOTES_WEIGH_BRIDGE_TICKET_LIST:
            // Restructure Export Data 
            csv_data = data?.map((delivery_notes) => ({
                delivery_note_ref_number: delivery_notes?.delivery_note?.delivery_note_ref_number,
                user_account_no: delivery_notes?.user_account?.unique_identification_number,
                product_name: joinUniqueProductNames(
                    delivery_notes?.product_list,
                    delivery_notes?.loading_order?.products,
                    delivery_notes?.delivery_note?.product_list,
                    delivery_notes?.delivery_note_products,
                ),
                property_area: delivery_notes?.user_property?.property_area,
                property_physical_address: delivery_notes?.user_property?.property_physical_address,
                truck_licence_plate: resolveTruckRegistration(delivery_notes),
                tonnage: formatWeighbridgeWeightMt(
                    resolveWeighbridgeNetWeight(
                        delivery_notes?.weigh_bridge_ticket?.net_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.first_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.second_weight || "",
                    ),
                    { fallback: "--" }
                ),
                tare_weight: delivery_notes?.weigh_bridge_ticket?.first_weight ? parseFloat(delivery_notes?.weigh_bridge_ticket?.first_weight || 0.00).toFixed(2) : "--",
                gross_weight: delivery_notes?.weigh_bridge_ticket?.second_weight ? parseFloat(delivery_notes?.weigh_bridge_ticket?.second_weight || 0.00).toFixed(2) : "--",
                net_weight: delivery_notes?.weigh_bridge_ticket?.first_weight && delivery_notes?.weigh_bridge_ticket?.second_weight
                    ? resolveWeighbridgeNetWeight(
                        delivery_notes?.weigh_bridge_ticket?.net_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.first_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.second_weight || "",
                    )
                    : "--",
                time_in: delivery_notes?.weigh_bridge_ticket?.time_in ? moment(delivery_notes?.weigh_bridge_ticket?.time_in).format("YYYY-MM-DD h:mm:ss") : "--",
                time_out: delivery_notes?.weigh_bridge_ticket?.time_out ? moment(delivery_notes?.weigh_bridge_ticket?.time_out).format("YYYY-MM-DD h:mm:ss") : "--",
                weigh_bridge_ticket_reference_no: delivery_notes?.weigh_bridge_ticket?.weigh_bridge_ticket_reference_no,
                weigh_bridge_ticket_status: delivery_notes?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status,
                weigh_bridge_ticket_type: delivery_notes?.weigh_bridge_ticket_type?.weigh_bridge_ticket_type,
                branch_area: delivery_notes?.branch_location?.branch_area,
                branch_physical_address: delivery_notes?.branch_location?.branch_physical_address,
                consigner_type: delivery_notes?.consigner_type?.consigner_type,
                created_date: delivery_notes?.delivery_note?.created_date ? moment(delivery_notes?.delivery_note?.created_date).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.CLIENT_DELIVERY_NOTES_LIST:
            // Restructure Export Data
            csv_data = data?.map((delivery_notes) => ({
                delivery_note_ref_number: delivery_notes?.delivery_note?.delivery_note_ref_number || "--",
                delivery_location: delivery_notes?.delivery_note?.delivery_location || "--",
                product_name: joinUniqueProductNames(
                    delivery_notes?.product_list,
                    delivery_notes?.loading_order?.products,
                    delivery_notes?.delivery_note?.product_list,
                    delivery_notes?.delivery_note_products,
                ),
                weigh_bridge_ticket_reference_no: delivery_notes?.weigh_bridge_ticket?.weigh_bridge_ticket_reference_no || "--",
                truck_licence_plate: resolveTruckRegistration(delivery_notes),
                tonnage: formatWeighbridgeWeightMt(
                    resolveWeighbridgeNetWeight(
                        delivery_notes?.weigh_bridge_ticket?.net_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.first_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.second_weight || "",
                    ),
                    { fallback: "--" }
                ),
                tare_weight: delivery_notes?.weigh_bridge_ticket?.first_weight ? parseFloat(delivery_notes?.weigh_bridge_ticket?.first_weight || 0.00).toFixed(2) : "--",
                gross_weight: delivery_notes?.weigh_bridge_ticket?.second_weight ? parseFloat(delivery_notes?.weigh_bridge_ticket?.second_weight || 0.00).toFixed(2) : "--",
                net_weight: delivery_notes?.weigh_bridge_ticket?.first_weight && delivery_notes?.weigh_bridge_ticket?.second_weight
                    ? resolveWeighbridgeNetWeight(
                        delivery_notes?.weigh_bridge_ticket?.net_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.first_weight || "",
                        delivery_notes?.weigh_bridge_ticket?.second_weight || "",
                    )
                    : "--",
                time_in: delivery_notes?.weigh_bridge_ticket?.time_in ? moment(delivery_notes?.weigh_bridge_ticket?.time_in).format("YYYY-MM-DD h:mm:ss") : "--",
                time_out: delivery_notes?.weigh_bridge_ticket?.time_out ? moment(delivery_notes?.weigh_bridge_ticket?.time_out).format("YYYY-MM-DD h:mm:ss") : "--",
                weigh_bridge_ticket_status: delivery_notes?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status || "--",
                weigh_bridge_ticket_type: delivery_notes?.weigh_bridge_ticket?.weigh_bridge_ticket_type || delivery_notes?.weigh_bridge_ticket_type?.weigh_bridge_ticket_type || "--",
                created_date: delivery_notes?.delivery_note?.created_date ? moment(delivery_notes?.delivery_note?.created_date).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.CUSTOMER_USER_ACCOUNT_LIST:
            // Restructure Export Data 
            csv_data = data?.map((customer) => ({
                username: customer?.user_account?.username,
                first_name: customer?.user?.first_name,
                surname: customer?.user?.surname,
                email_address: customer?.user?.email_address,
                phone_number: customer?.user?.phone_number,
                account_status: customer?.account_status?.account_status,
                date_created: customer?.user_account?.date_created ? moment(customer?.user_account?.date_created).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.COMPANY_USER_ACCOUNT_LIST:
            // Restructure Export Data 
            csv_data = data?.map((company) => ({
                username: company?.user_account?.username,
                company_name: company?.company?.company_name,
                company_email_address: company?.company?.company_email_address,
                company_mobile_number: company?.company?.company_mobile_number,
                account_status: company?.account_status?.account_status,
                date_created: company?.user_account?.date_created ? moment(company?.user_account?.date_created).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.TRUCK_DRIVER_USER_ACCOUNT_LIST:
            // Restructure Export Data 
            csv_data = data?.map((truck_driver) => ({
                username: truck_driver?.user_account?.username,
                first_name: truck_driver?.user?.first_name,
                surname: truck_driver?.user?.surname,
                email_address: truck_driver?.user?.email_address,
                phone_number: truck_driver?.user?.phone_number,
                account_status: truck_driver?.account_status?.account_status,
                date_created: truck_driver?.user_account?.date_created ? moment(truck_driver?.user_account?.date_created).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.EMPLOYEE_LIST_TYPE:
            // Restructure Export Data 
            csv_data = data?.map((employee) => ({
                employee_no: employee?.user_account?.unique_identification_number,
                first_name: employee?.user?.first_name,
                surname: employee?.user?.surname,
                phone_number: employee?.user?.phone_number,
                employee_role: employee?.employee_role?.role_name,
                employee_department: employee?.employee_department?.department_name,
                account_status: employee?.user_account?.account_status,
                branch_area: employee?.branch_location?.branch_area,
                branch_physical_address: employee?.branch_location?.branch_physical_address,
                date_created: employee?.employee?.inserted_at ? moment(employee?.employee?.inserted_at).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
        case app_consts.BRANCH_LOCATION_LIST:
            // Restructure Export Data 
            csv_data = data?.map((branch_location) => ({
                branch_area: branch_location?.branch_area,
                branch_physical_address: branch_location?.branch_physical_address,
                branch_mobile_number: branch_location?.branch_mobile_number,
                province_name: branch_location?.province_name,
                account_status: branch_location?.account_status,
                date_created: branch_location?.branch_registered_date ? moment(branch_location?.branch_registered_date).format("YYYY-MM-DD h:mm:ss") : "--",
            }));
            break;
    }
    return csv_data;
}; 
